module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('static.orders.edit.exciseModalFormTitle')) + " " + _vm._s(_vm.productName))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.form,
      "hasLabel": true,
      "translation": "form.products",
      "save": _vm.onSubmit
    }
  }) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-593382eb","hasScoped":true}!./src/app/components/quickProductEditExcise/quickProductEditExcise.html
// module id = 3022
// module chunks = 1